import { useEffect, useState } from "react";
import { ClearIcon } from "@/components/icons";

interface InputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  classNames?: string;
  onFocusChange?: (focus: boolean) => void;
  autoFocus?: boolean;
}

const Input = ({
  value,
  onChange,
  placeholder,
  classNames,
  onFocusChange,
  autoFocus = false,
}: InputProps) => {
  const [clearVisible, setClearVisible] = useState(false);
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (value) {
      setClearVisible(true);
    } else {
      setClearVisible(false);
    }
  }, [value]);

  return (
    <div
      className={`relative flex items-center justify-center w-full h-[48px] bg-[#f5f5f5] text-[#333]  ${classNames}`}
    >
      <input
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        onFocus={(e) => {
          setFocused(true);
          setTimeout(() => {
            // 打印当前视口的高度
            console.log(
              "滚动前window.innerHeight",
              window.visualViewport?.height
            );
            e.target.scrollIntoView({ behavior: "smooth", block: "start" });
            // 打印滚动后的视口高度
            console.log(
              "滚动后window.innerHeight",
              window.visualViewport?.height
            );
          }, 300);
        }}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        className="w-full h-full pe-[48px] bg-transparent outline-none border-[none] placeholder:text-[#ccc] placeholder:font-[700] placeholder:font-[16px]"
        maxLength={32}
      />
      <div
        className="absolute right-[16px] top-1/2 -translate-y-1/2 cursor-pointer"
        onMouseDown={(e) => {
          // 阻止按下清理按钮时触发 input 的失焦
          e.preventDefault();
        }}
        onClick={() => {
          onChange("");
        }}
      >
        {clearVisible && focused ? <ClearIcon /> : null}
      </div>
    </div>
  );
};

export default Input;
